
const eng = {
  'av': 'of',
  'Avbryt': 'Cancel',
  'Betalning': 'Payment',
  'eller e-post': 'or email',
  'er': 's', // 'er' i månader blir 's' i months
  'E-post': 'Email',
  'Fortsätt': 'Next',
  'Frågor': 'Questions',
  'från': 'from',
  'Glömt lösenord': 'Forgot password',
  'Kom ihåg mig': 'Remember me',
  'kr': 'SEK', // Tills vidare (ingen valuta konvertering)
  'Logga in': 'Login',
  'Logga ut': 'Logout',
  'Läs mer': 'Read more',
  'Lösenord': 'Password',
  'Medlemskap': 'Membership',
  'månad': 'month',
  'Ring': 'Call',
  'Steg': 'Step',
  'Tillbaka': 'Back',
  'Välj': 'Choose',
  'Återställ lösenord': 'Reset password',
}

export default eng
